import { ITypeTicketCollectionData } from 'meta/pages/v4/typeticketcollection'
import { SliceSelector } from 'store/types'

const getTypeTicketCollectionData: SliceSelector<ITypeTicketCollectionData | undefined, { id: number }> =
  ({ id }) =>
  (state) =>
    state.pages.typeticketcollection.typeticketcollections[id]

const getTypeTicketCollectionBulkDetails: SliceSelector<ITypeTicketCollectionData[] | undefined, { ids: number[] }> =
  ({ ids }) =>
  (state) => {
    return ids
      .map((id) => state.pages.typeticketcollection.typeticketcollections[id])
      .filter(Boolean) as ITypeTicketCollectionData[]
  }

export const TypeTicketCollectionSelectors = {
  getTypeTicketCollectionData,
  getTypeTicketCollectionBulkDetails
}
